import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from './blogData';
import './BlogPage.css';
import { Helmet } from 'react-helmet';
import GoogleFixedAds from '../../components/googleAds/GoogleFixedads';
import { GOOGLE_ADS_CLIENT } from '../../lib/config';

function getCurrentDate() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = String(now.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
}

const BlogPage = () => {
    return (
        <>
            <Helmet>
                <title>LED Display Blog | LED Scroller</title>
                <meta name="description" content="Discover insights, tips, and best practices for creating effective LED displays and signs. Read our latest blog posts on LED technology, design, and more." />
                <meta property="og:title" content="LED Display Blog | LED Scroller" />
                <meta property="og:description" content="Discover insights, tips, and best practices for creating effective LED displays and signs. Read our latest blog posts on LED technology, design, and more." />
                <meta property="og:type" content="blog" />
                <meta property="og:url" content="https://ledscroller.com/blog" />
                <script type="application/ld+json">{`
                  {
                    "@context": "https://schema.org",
                    "@type": "Blog",
                    "name": "LED Display Blog",
                    "description": "Discover insights, tips, and best practices for creating effective LED displays and signs.",
                    "url": "https://ledscroller.com/blog"
                  }
                `}</script>
            </Helmet>
            <div className="blog-page">
                <div className="container contact-header">
                    <h1 className="blog-title">LED Display Blog</h1>
                    <p className="blog-description">
                        Discover insights, tips, and best practices for creating effective LED displays and signs.<br/>
                        <Link to="/about">About Us</Link> | <Link to="/contact">Contact Us</Link>
                    </p>
                    
                    <div className="blog-grid">
                        {blogPosts.map(post => (
                            <div key={post.id} className="blog-card">
                                <div className="blog-card-image">
                                    <img src={post.listingImage} alt={post.title} />
                                </div>
                                <div className="blog-card-content">
                                    <div className="blog-card-meta">
                                        <span className="blog-card-date">{getCurrentDate()}</span>
                                        <span className="blog-card-category">{post.category}</span>
                                    </div>
                                    <h2 className="blog-card-title">{post.title}</h2>
                                    <p className="blog-card-summary">{post.summary}</p>
                                    <div className="blog-card-tags">
                                        {post.tags.map(tag => (
                                            <span key={tag} className="blog-card-tag">{tag}</span>
                                        ))}
                                    </div>
                                    <Link to={`/blog/${post.id}`} className="blog-card-link">
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-12 d-flex justify-content-center'>
                <div className='google-ads-container'>
                    <div className='google-ads-responsive'>
                        <GoogleFixedAds
                            style={{ display: 'block', width: '100%', height: 'auto' }}
                            client={GOOGLE_ADS_CLIENT}
                            slot="1216543310"
                            format="autorelaxed"
                        />    
                    </div>
                </div>
                </div>
            </div>
        </>
    );
};

export default BlogPage; 